import { useEffect, useState } from 'react';
import api from '../../api/client';

// Cartel rojo fijo con el número de oyentes en vivo de la radio.
// Vive en la StatusBar del layout, así queda visible en TODAS las secciones
// del AutoDJ, a la altura del cartel ONLINE.
//
// Muestra "Oyentes" + el total real (externos + web, sin relay ni monitor),
// tomado del snapshot que publica listener-geo cada 30 s.
export default function ListenersBadge() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .get('/api/stats/listener-connections')
        .then(({ data }) => {
          if (alive) setCount(data?.total ?? 0);
        })
        .catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  return (
    <span
      title="Oyentes en vivo ahora (externos + web, sin relay ni monitor)"
      className="flex h-9 shrink-0 items-center gap-1.5 rounded-md border border-error-500 bg-error-600 px-2.5 shadow-[0_0_10px_rgba(220,38,38,.55)]"
    >
      <span className="text-[11px] font-bold uppercase tracking-wider text-white">Oyentes</span>
      <span className="text-xl font-extrabold leading-none tabular-nums text-white">
        {count ?? '…'}
      </span>
    </span>
  );
}
